import gql from 'graphql-tag';

export const PagesSpaceIdQuery = gql`
	query PagesSpaceIdQuery($spaceKey: String) {
		space(key: $spaceKey) {
			id
		}
	}
`;
